import { useEffect, useState } from 'react'
import { PageLatencyTracker } from '@amzn/ihm-associate-tools-js-lib'

interface IPageLatencyTrackingProps {
    latencyTracker: PageLatencyTracker,
}

export const usePageLatencyTracking = (props: IPageLatencyTrackingProps) => {
    const { latencyTracker } = props

    if (!latencyTracker) {
        console.warn('Cannot use page latency tracking without latencyTracker obj given')
        return
    }

    const [hasBeenConstructed, setHasBeenConstructed] = useState(false)

    if (!hasBeenConstructed) {
        latencyTracker.checkpoint('FirstByte')
        setHasBeenConstructed(true)
    }

    useEffect(() => {
        latencyTracker.checkpoint('Render')
    }, [])
}
